// extracted by mini-css-extract-plugin
export default {"root":"Breadcrumb_root__2vXER","active":"Breadcrumb_active__02+NO","parent":"Breadcrumb_parent__FbVrD","separator":"Breadcrumb_separator__CX0dM"};